function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-[12px] text-fg-subtle">
      <div>
        Made with React, TypeScript, and Tailwind
        <span aria-hidden="true" className="mx-2 opacity-60">·</span>
        {year}
      </div>
      <a
        href="https://github.com/faxonchris/react-developer-resume"
        target="_blank"
        rel="noreferrer"
        className="hover:text-accent transition-colors"
      >
        Source on GitHub ↗
      </a>
    </footer>
  );
}

export default Footer;
